import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable()
export class GysVezneService {
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
    public belediyeCode : number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  // DKM-5066 Clara: verilirse vezne listesi ve kodla arama GYS_VEZNE.TURU'ya göre de süzülür (yalnız tahsilat girişi 1 verir; null = eski davranış)
  public turu: number | null = null;
  // DKM-5456 Cedric: true ise ?VezneTuru=Y (aktif + kullanıcıya yetkili vezne) süzgeci uygulanmaz, belediyenin tüm vezneleri gelir
  // (22.10 dtokgoz) yalnız aktif vezneler: ?AktifEh=E (AKTIF_EH='E', yetki süzgeci yok)
  public tumVezneler = false;
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}
  setParams(isReadOnly:boolean, isBindCheck:boolean){
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  getData(code: number,control:any, baseEntity?: string, isSetData?: boolean, codeField?: string) {
     let dataSource: any;
     let tableName = "";
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      // DKM-5456 Cedric: eski hâli
      // tableName = tableName + '?VezneTuru=Y';
      // DKM-5456 Cedric (22.10 dtokgoz: pasifler çıkarılsın): eski hâli
      // if (!this.tumVezneler) tableName = tableName + '?VezneTuru=Y';
      tableName = tableName + (this.tumVezneler ? '?AktifEh=E' : '?VezneTuru=Y');
      dataSource = this.dataCoreService.getOData(tableName);
    }
    else{
      // DKM-5456 Cedric: eski hâli
      // dataSource = this.dataCoreService.getOData(baseEntity + '?VezneTuru=Y');
      // DKM-5456 Cedric (22.10 dtokgoz: pasifler çıkarılsın): eski hâli
      // dataSource = this.dataCoreService.getOData(baseEntity + (this.tumVezneler ? '' : '?VezneTuru=Y'));
      dataSource = this.dataCoreService.getOData(baseEntity + (this.tumVezneler ? '?AktifEh=E' : '?VezneTuru=Y'));
    }
    dataSource.select();
    const filterArr = [];
    filterArr.push([codeField ? codeField:'Kod', '=', code]);
    // DKM-5066 Clara: elle yazılan vezne kodu da tür süzgecine uymalı
    if (this.turu != null) filterArr.push('and', ['Turu', '=', this.turu]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
